import React from "react";
import { DocumentTextIcon, EmptyDocument } from "asset/icons";

const DocumentTab = ({ documents }) => {
    return (
        <div className="">
            {documents.length > 0 ? (
                <div className="border rounded-lg border-light-grey">
                    {documents.map((doc, index) => (
                        <div
                            key={index}
                            className="flex items-center justify-between p-4 transition border-b cursor-pointer rounded-xl border-b-light-grey last:border-none hover:bg-gray-100"
                        >
                            <div className="flex items-center gap-2">
                                <DocumentTextIcon className="text-purple-500" />
                                <p className="font-medium text-main-dark">{doc.name}</p>
                            </div>
                            <p className="overflow-hidden text-sm text-right text-gray-500 whitespace-nowrap text-ellipsis md:w-1/2">
                                {doc?.key || doc.name + "." + doc?.url?.split(".").at(-1)}
                            </p>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="flex flex-col items-center justify-center py-20">
                    <EmptyDocument />
                    <p className="mt-5 text-lg font-semibold text-main-dark">No documents here</p>
                </div>
            )}
        </div>
    );
};

export default DocumentTab;
